export * from "@piwikpro/tracking-base-library";
import { default as default2 } from "@piwikpro/tracking-base-library";
export {
  default2 as default
};
//# sourceMappingURL=index.js.map
